"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const data_1 = require("../../../data");
const usefulAddressFilters = (0, graphql_tag_1.default)`
  ${data_1.userPopupSchemaFields}
  query useful_address_filtersList {
    usefulAddress {
      filtersList {
        name
        type
        items {
          count
          value
          name
          user {
            ...userPopupSchemaFields
          }
          icon
          iconColor
          backgroundColor
          countColor
          isVisible
          ownedArea
          ownershipPercent
          address
          buildingId
        }
      }
    }
  }
`;
exports.default = usefulAddressFilters;